(() => {
  if (window.hovHomepageReady) return;
  window.hovHomepageReady = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-hov-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    button.disabled = true;
    button.textContent = 'Adding...';
    status.textContent = '';
    try {
      const response = await fetch(form.action + '.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add to bag. Please try again.');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (typeof window.hovShowAddedToBag === 'function') window.hovShowAddedToBag();
    } catch (error) { status.textContent = error.message; }
    finally { button.disabled = false; button.textContent = 'Quick add'; }
  });
})();
